import './flat-loader.scss'
import React from 'react'

export const FlatLoader: React.FC = () => {
  return (
    <div className="relative flat-loader overflow-hidden h-2 rounded-lg">
      <div className="absolute bg-action-default h-2 flat-loader__line rounded-lg"></div>
    </div>
  )
}
